export function formatDate(date) {
	const d = date instanceof Date ? date : new Date(date);
	return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
}

export function formatCurrency(amount) {
	const n = Number(amount) || 0;
	return n.toLocaleString(undefined, { style: 'currency', currency: 'USD' });
}

export function formatCredits(amount) {
	const n = Number(amount) || 0;
	return `${n} credits`;
}

export function timeAgo(date) {
	const d = date instanceof Date ? date : new Date(date);
	const seconds = Math.floor((Date.now() - d.getTime()) / 1000);
	const intervals = [
		{ label: 'year', secs: 31536000 },
		{ label: 'month', secs: 2592000 },
		{ label: 'day', secs: 86400 },
		{ label: 'hour', secs: 3600 },
		{ label: 'minute', secs: 60 }
	];
	for (const { label, secs } of intervals) {
		const v = Math.floor(seconds / secs);
		if (v >= 1) return `${v} ${label}${v > 1 ? 's' : ''} ago`;
	}
	return 'just now';
}


